import { eventBus } from "../eventbus.js";

export default {
  methods: {
    manageCounter: function(){
      var vm = this;
      //source: www.codeply.com/go/2VmBU7TanF/bootstrap-plus-minus-counter-input
      $('.popup-btn-number').unbind().click(function(e){ //unbind() per evitare che l'evento si propaghi per più volte
        var fieldName = $(this).attr('data-field'),
            type = $(this).attr('data-type'),
            input = $("input[name='"+fieldName+"']"),
            currentVal = parseFloat(input.val());
        if (!isNaN(currentVal)) {
            if(type == 'minus') {
                if(currentVal > input.attr('min')) {
                  if(vm.product.refObj.mqd){
                    input.val((currentVal - 0.1).toFixed(1)).change();
                  }else if(vm.product.refObj.pib){
                    input.val(currentVal - vm.product.refObj.pib).change();
                  }else{
                    input.val(currentVal - 1).change();
                  }
                } 
                if(parseFloat(input.val()) == input.attr('min')) {
                    $(this).attr('disabled', true);
                }
            } else if(type == 'plus') {
                if(currentVal < input.attr('max')) {
                  if(vm.product.refObj.mqd){
                    input.val((currentVal + 0.1).toFixed(1)).change();
                  }else if(vm.product.refObj.pib){
                    input.val(currentVal + vm.product.refObj.pib).change();
                  }else{
                    input.val(currentVal + 1).change();
                  }
                }
                if(parseFloat(input.val()) == input.attr('max')) {
                    $(this).attr('disabled', true);
                }
            }
        } else {
            input.val(0);
        }
      });

      $('.popup-input-number').focusin(function(){
        $(this).data('oldValue', $(this).val());
      });

      $('.popup-input-number').change(function(event) {
        var minValue =  parseFloat($(this).attr('min')),
            maxValue =  parseFloat($(this).attr('max')),
            valueCurrent = parseFloat($(this).val()),
            name = $(this).attr('name');
        if(valueCurrent % 1 != 0){ //il valore inserito è decimale?
          if(vm.product.refObj.mqd){
            if(valueCurrent >= minValue) {
              $(".popup-btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
            }else{
              console.log('mixin - the minimum value was reached');
              $(this).val($(this).data('oldValue'));
            }
            if(valueCurrent <= maxValue) {
              $(".popup-btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
            }else{
              console.log('mixin - the maximum value was reached');
              $(this).val($(this).data('oldValue'));
            }
          }else{
            $(this).val(vm.minQuantity);
          }
        }else{
          if(vm.product.refObj.pib && (valueCurrent % vm.product.refObj.pib != 0)){ //il valore non è multiplo dei pezzi per confezione
            var mult = parseInt(valueCurrent / vm.product.refObj.pib)
            var correct = vm.product.refObj.pib * mult
            $(this).val(correct);
          }
          if(valueCurrent >= minValue) {
            $(".popup-btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
          }else{
            console.log('mixin - the minimum value was reached');
            $(this).val($(this).data('oldValue'));
          }
          if(valueCurrent <= maxValue) {
            $(".popup-btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
          }else{
            console.log('mixin - the maximum value was reached');
            $(this).val($(this).data('oldValue'));
          }
        }
      });

      $(".popup-input-number").keydown(function (e) {
        //se si preme invio, metto il prodotto in carrello
        if (e.keyCode == 13 ){
          //DO nothing
          //TODO: gestire eventualmente l'inserimento in carrello
          /* eventBus.$emit('putInCart');
          e.stopImmediatePropagation() */
        }
        //se premo un altro tasto, non fare niente
        // Allow: backspace, delete, tab, escape and .
        if(vm.product.refObj.mqd){ //permetto l'inserimento di punti e virgole
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190, 110, 188]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) || 
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
          }
        }else{
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) || 
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
          }
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/purchasepopup_mixin.js